import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Observable} from 'rxjs';
import {CustomerAccountDetail} from '../entity';

@Injectable()
export class CommonCustomerAccountService {

    constructor(private _http: Http) {
    }

    getCustomerAccount(customerAccountId: number): Observable<CustomerAccountDetail> {
        return this._http.get(`/api/backoffice/customer-accounts/${customerAccountId}`)
            .map(response => response.json());
    }

    saveCustomerToLiquidityAccountLinkOptions(customerAccountId: number, liquidityAccountId: number, allowIncoming: boolean, allowOutgoing: boolean) {
        return this._http.patch(`/api/backoffice/customer-accounts/${customerAccountId}/liquidity-accounts/${liquidityAccountId}?options`, {}, {
            search: {
                'incoming': allowIncoming,
                'outgoing': allowOutgoing
            }
        }).map(response => response.json());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/service/common-customer-account.service.ts